// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'qr';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.563 9.563v1.124h1.125M5.063.563h-4.5v4.5h4.5zm12.375 0h-4.5v4.5h4.5zM5.063 12.938h-4.5v4.5h4.5zM9 .563h1.688m-3.375 0v2.25H9m1.688 0v2.25H7.312M.563 7.313h4.5v1.125m-1.125 2.25h1.124m12.376 6.75h-2.25v-2.25h2.25v-2.25h-2.25m-4.5 4.5H7.312v-4.5m5.626 0v4.5m-3.375-4.5h1.124v2.25H9.563m-2.25-5.625v1.124h1.125m2.25.001h2.25m-1.125 0v-2.25m-4.5-1.125h2.25v1.125m7.875-1.125v1.125m0 1.687v.563m-3.375-3.375v1.125h1.124v1.687'
  />
);

export const viewBox = '0 0 18 18';
